import { useEffect, useState } from "react";
import AssessmentQuestion from "./AssessmentQuestion";
import SuccessBee from "../../../../assets/images/SuccessBee.svg";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";

import { useDispatch, useSelector } from "react-redux";
import userProfileSelectors from "../../../../../redux/UserProfile/selectors"
import { createAssessment, setAssessmentCreationSuccess } from "Store/AssetInventory/Assessments/AssessmentAction";
import { getQuestionOptions } from "Store/AssetInventory/QuestionOption/QuestionOptionAction";
import { CONSTANTS } from "client/utils/constants";

const AssessmentQuestionContainer = (props: any) => {
  const { 
    quantity: questionQuantity, 
    assessmentTitle, 
    passingPercentage, 
    handleClickBack,
    assessmentById = {},
    isEditMode = false
  } = props

  const dispatch = useDispatch()
  const [quantity, setQuantity] = useState(1)
  const [questionList, setQuestionList] = useState<any>([])
  const [showAssessmentAnswer, setShowAssessmentAnswer] = useState(false)
  const [questionTypes, setQuestionType] = useState<any>([])

  useEffect(()=>{
    dispatch(getQuestionOptions())
  }, [])

  const { userDetails, assessmentCreated, questionOptions }: any = useSelector(
    (state: any) => ({
      userDetails: userProfileSelectors.getUserDetails(state),
      assessmentCreated: state.AssessmentReducer.assessmentCreated,
      questionOptions : state.AssetInventoryQuestionOptionReducer.questionOptions
    }));

  useEffect(() => {
    questionOptionTypes()
  }, [questionOptions.length])

  const questionOptionTypes = () => {
    const questionTypesTemp = JSON.parse(JSON.stringify(questionOptions)).map((option: any) => ({
      ...option,
      label: option.text
    }));
    setQuestionType(questionTypesTemp)
  }
  

  const initialState = {
    question: '',
    questionError: '',
    optionType: '',
    optionTypeError: '',
    noOfOptions: 1,
    noOfOptionsError: '',
    answerOption: '',
    answerOptionError: '',
    questionIndex: 0,
    options: [],
    isValid: false,
  }

  const initialOptionState = {
    optionValue: '',
    isAnswer: false,
    optionIndex: 0,
    optionError: ''
  }

  useEffect(()=>{
    if(questionTypes?.length && questionTypes?.length === 1){
      let questionListTemp = questionList?.map((question: any) => ({...question, optionType: questionTypes[0].value}))
      setQuestionList(questionListTemp)
    }
  }, [questionTypes])

  useEffect(() => {
    if (assessmentById?.assessmentId) {
      let questionListTemp = JSON.parse(JSON.stringify(assessmentById))
      let ApiToReactData = questionListTemp?.assessmentQuestionVM?.reduce((acc: any[], cur: any, idx: number) => {
        let question: any = {}
        let options: any = []
          question.question = cur.question
          question.questionError = ''
          question.optionType = cur.optionTypeId
          question.optionTypeError = ''
          question.noOfOptions = cur.numberOfOptions
          question.noOfOptionsError = ''
          question.answerOptionError = ''
          question.questionIndex = cur.assesmentQuestionId
          question.isValid = false
          question.assesmentQuestionId = cur?.assesmentQuestionId
          question.assessmentId = cur?.assessmentId
          question.updatedBy = userDetails?.emailId
          question.savedBy = cur?.savedBy
          question.answerOption = ''


        if (cur.option1) {
          question.answerOption = (cur.Option1Answer && !question.answerOption) ? 1 : ''
          options.push({
            optionValue: cur.option1,
            isAnswer: cur.Option1Answer,
            optionIndex: 1,
            optionError: ''
          })
        }
        if (cur.option2) {
          question.answerOption = (cur.Option2Answer && !question.answerOption) ? 2 : question.answerOption
          options.push({
            optionValue: cur.option2,
            isAnswer: cur.Option2Answer,
            optionIndex: 2,
            optionError: ''
          })
        }
        if (cur.option3) {
          question.answerOption = (cur.Option3Answer && !question.answerOption) ? 3 : question.answerOption
          options.push({
            optionValue: cur.option3,
            isAnswer: cur.Option3Answer,
            optionIndex: 3,
            optionError: ''
          })
        }
        if (cur.option4) {
          question.answerOption = (cur.Option4Answer && !question.answerOption) ? 4 : question.answerOption
          options.push({
            optionValue: cur.option4,
            isAnswer: cur.Option4Answer,
            optionIndex: 4,
            optionError: ''
          })
        }

    question.options = options
    question.noOfOptions = options?.length
    acc = acc.concat(question)
    return acc
      }, [])
      setQuestionList(ApiToReactData)
      setShowAssessmentAnswer(true)
    } else {
      let questionListTemp: any = Array.from({ length: questionQuantity }, (_, idx) => ({ ...initialState, questionIndex: ++idx }))
      setQuestionList(questionListTemp)
    }
  }, [])



  useEffect(() => {
    if (assessmentCreated === 'success') {
      let decriptionTxt = (<>
        <p>New Assessment created successfully</p>
        <p className="sub-heading-inventory">{assessmentTitle}</p>
      </>);
      setSubmitPopupcontent({
        ...submitPopupcontent,
        titleImg: SuccessBee,
        title: CONSTANTS.TITLE_SUCCESS,
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        popupOutlinebtnOnclick: () => {
          handleClickBack()
          setQuestionList([])
          setQuestionType([])
          setShowAssessmentAnswer(false)
          hideDialogSubmit()
        },
        isSingleConfirmationBtn: true,
      });
    } else if (assessmentCreated === 'failed') {
      let decriptionTxt = (<>
        <p>Error occured while creating the Assessment.</p>
        <p className="sub-heading-inventory">{assessmentTitle}</p>
      </>);
      setSubmitPopupcontent({
        ...submitPopupcontent,
        titleImg: ConfirmationBee,
        title: CONSTANTS.TITLE_CONFIRMATION,
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        popupOutlinebtnOnclick: popupOutlinebtnOnclickCancel,
        isSingleConfirmationBtn: true,
      });
    }
  }, [assessmentCreated])


  const onChangeQuestion = (value: string, questionIndex: number) => {
    const questionListTemp = JSON.parse(JSON.stringify(questionList))
    let newQuestionList = questionListTemp.map((question: any) => {
      if (question.questionIndex === questionIndex) {
        if (!value) {
          question.question = ''
          question.questionError = 'Please provide question'
        } else {
          question.question = value
          question.questionError = ''
        }
      }
      return question
    })
    setQuestionList(newQuestionList)
  }

  const onDeleteQuestion = (questionIndex: number) => {
    const questionListTemp = JSON.parse(JSON.stringify(questionList))
    const newQuestionList  = questionListTemp?.filter((question: any) => question?.questionIndex !== questionIndex)
    setQuestionList(newQuestionList)
  }


  const optionTypeOnChange = (e: any, item: any, questionIndex: number) => {
    const value = item.value
    const questionListTemp = JSON.parse(JSON.stringify(questionList))
    let newQuestionList = questionListTemp.map((question: any) => {
      if (question.questionIndex === questionIndex) {
        if (!value) {
          question.optionTypeError = 'Please select option type'
        } else {
          question.optionType = value
          question.optionTypeError = ''
        }
      }
      return question
    })
    setQuestionList(newQuestionList)
  }

  const onChangeQuantity = (e: any) => {
    if (e.target.value == '' || parseInt(e.target.value) == 0) {
      setQuantity(1);
    }
    else {
      setQuantity(parseInt(e.target.value));
    }
  }

  const incrementQuantity = (questionIndex: number) => {
    const questionListTemp = JSON.parse(JSON.stringify(questionList))
    let newQuestionList = questionListTemp.map((question: any) => {
      if (question.questionIndex === questionIndex && question.noOfOptions < 4) {
        question.noOfOptions = question.noOfOptions + 1
      }
      return question
    })
    setQuestionList(newQuestionList)
  }

  const decrementQuantity = (questionIndex: number) => {
    const questionListTemp = JSON.parse(JSON.stringify(questionList))
    let newQuestionList = questionListTemp.map((question: any) => {
      if (question.questionIndex === questionIndex && question.noOfOptions !== 1) {
        question.noOfOptions = question.noOfOptions - 1
      }
      return question
    })
    setQuestionList(newQuestionList)
  }

  const onClickAddAnswerBtn = (questionIndex: number) => {    
    let questionListTemp = questionList.map((question: any) => {
      if (question.questionIndex === questionIndex) {
        if(!question.question){
          question.questionError = 'Please provide question'
        }
        if (!question.optionType) {
          question.optionTypeError = 'Please select option type'
        }
        if(question.question && question.optionType && question.noOfOptions > 0){
          if(question.options?.length){
            let highestOptionIndex = question.options.reduce((accumulator: any, current: any) => {
              return accumulator > current.optionIndex ? accumulator : current.optionIndex;
            }, 0);
            let optionListTemp: any = Array.from({ length: (question?.noOfOptions -  question.options?.length)}, (_, idx) => ({ ...initialOptionState, optionIndex: ++highestOptionIndex }))
            question.options = [...question.options, ...JSON.parse(JSON.stringify(optionListTemp))]
          }else{
            let optionListTemp: any = Array.from({ length: question?.noOfOptions }, (_, idx) => ({ ...initialOptionState, optionIndex: ++idx }))
            question.options = JSON.parse(JSON.stringify(optionListTemp))
          }
          question.noOfOptionsError = ''
          setShowAssessmentAnswer(true)
        }
      }
      return question
    })
    setQuestionList(questionListTemp)
  }

  const onChangeOption = (value: string, questionIndex: number, optionIndex: number) => {
    const questionListTemp = JSON.parse(JSON.stringify(questionList))
    let newQuestionList = questionListTemp.map((question: any) => {
      if (question.questionIndex === questionIndex) {
        question.options.forEach((option: any) => {
          if (option.optionIndex === optionIndex) {
            if (!value) {
              option.optionValue = ''
              option.optionError = 'Please provide option value'
            } else {
              option.optionValue = value
              option.optionError = ''
            }
          }
        })
      }
      return question
    })
    setQuestionList(newQuestionList)
  }

  const onDeleteOption = (questionIndex: number, optionIndex: number) => {
    const questionListTemp = JSON.parse(JSON.stringify(questionList))
    questionListTemp?.forEach((question: any) => {
      if (question.questionIndex === questionIndex) {
        question.options = question?.options?.filter((option: any) => option.optionIndex !== optionIndex)
        question.noOfOptions = question.options?.length
      if (question?.answerOption === optionIndex) {
        question.answerOption = ''
      }
    }
    })
    setQuestionList(questionListTemp)
  }

  const onChangeOptionAnswer = (value: boolean, questionIndex: number, optionIndex: number) => {
    const questionListTemp = JSON.parse(JSON.stringify(questionList))
    let newQuestionList = questionListTemp.map((question: any) => {
      if (question.questionIndex === questionIndex) {
        question.options.forEach((option: any) => {
          if (option.optionIndex === optionIndex && value) {
            option.isAnswer = value
            question.answerOption = optionIndex
            question.answerOptionError = ''
          } else if (option.optionIndex === optionIndex && !value) {
            option.isAnswer = value
            if (question.optionType != 1) {
              question.answerOption = ''
            } else {
              question.answerOption = question?.options?.find((op: any) => op?.isAnswer)?.optionIndex
            }
          } else {
            if (question.optionType != 1) {
              option.isAnswer = false
            }
          }
        })
      }
      return question
    })
    setQuestionList(newQuestionList)
  }


  const [submitPopupcontent, setSubmitPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    outlineBtnText: "",
    popupOutlinebtnOnclick: () => { },
    pupPrimarybtnOnclick: () => {},
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });

  const hideDialogSubmit = () => {
    setSubmitPopupcontent({ ...submitPopupcontent, isDialogVisible: false })
    dispatch(setAssessmentCreationSuccess(''))
  };

  const popupOutlinebtnOnclickCancel = () => {
    hideDialogSubmit();
  };

  const isValidOptions = (question: any) => {
    let isValid = true
    let invalidOptions: any = [];
    if (question?.options?.length) {
      question?.options?.forEach((option: any) => {
        if (!option.optionValue) {
          invalidOptions.push(option)
        }
      })
    }
    if (invalidOptions?.length > 0) {
      isValid = false
    }
    return isValid
  }


  const validateQuestions = () => {
    let isValid = true
    let invalidQuestions: any = [];
    const questionListTemp = JSON.parse(JSON.stringify(questionList))
    questionListTemp.forEach((question: any) => {
      if (!question?.question) {
        question.questionError = 'Please provide question'
      } else {
        question.questionError = ''
      }
      if (!question.optionType) {
        question.optionTypeError = 'Please select option type'
      } else {
        question.optionTypeError = ''
      }
      if (!question.answerOption && question?.options?.length) {
        question.answerOptionError = 'Please select atleast one option as answer'
      } else {
        question.answerOptionError = ''
      }

      if (question?.options?.length) {
        question?.options?.forEach((option: any) => {
          if (!option.optionValue) {
            option.optionError = 'Please provide option value'
          } else {
            option.optionError = ''
          }
        })
      } else {
        question.noOfOptionsError = 'Please Add Answer Options'
      }

      if (!question?.question || !question.optionType || !question.answerOption || !isValidOptions(question)) {
        question.isValid = false
        invalidQuestions.push(question)
      } else {
        question.isValid = false
      }
    })
    if (invalidQuestions?.length > 0) {
      isValid = false
    }
    setQuestionList(questionListTemp)
    return isValid
  }

  const handleClickSubmit = () => {
    let isValid = validateQuestions()
    if (isValid && assessmentTitle && passingPercentage > 0 && passingPercentage <= 100) {
      let payload: any = {}
      let assessmentQuestionVMTemp: any = questionList?.reduce((acc: any[], question: any) => {
        let assessmentQuestionVMObject: any = {}
        assessmentQuestionVMObject.assesmentQuestionId = question?.assesmentQuestionId ?? 0;
        assessmentQuestionVMObject.assessmentId = question?.assessmentId ?? 0;
        assessmentQuestionVMObject.question = question.question;
        assessmentQuestionVMObject.optionTypeId = question.optionType;
        assessmentQuestionVMObject.numberOfOptions = question?.options?.length;
        assessmentQuestionVMObject.option1 = question?.options[0]?.optionValue ?? '';
        assessmentQuestionVMObject.option2 = question?.options[1]?.optionValue ?? '';
        assessmentQuestionVMObject.option3 = question?.options[2]?.optionValue ?? '';
        assessmentQuestionVMObject.option4 = question?.options[3]?.optionValue ?? '';
        assessmentQuestionVMObject.Option1Answer = question?.options[0]?.isAnswer ?? false;
        assessmentQuestionVMObject.Option2Answer = question?.options[1]?.isAnswer ?? false;
        assessmentQuestionVMObject.Option3Answer = question?.options[2]?.isAnswer ?? false;
        assessmentQuestionVMObject.Option4Answer = question?.options[3]?.isAnswer ?? false;
        assessmentQuestionVMObject.correctAnswer = "";
        assessmentQuestionVMObject.description = "";
        assessmentQuestionVMObject.isActive = true;
        assessmentQuestionVMObject.savedBy = question.savedBy ?? ''
        assessmentQuestionVMObject.updatedBy = question.updatedBy ?? ''
        acc.push(assessmentQuestionVMObject);
        return acc;
      }, [])


      payload.assessmentId = assessmentById?.assessmentId ?? 0;
      payload.assessmentTitle = assessmentTitle;
      payload.scoreTypeId = 1;
      payload.passingPercentage = passingPercentage;
      payload.numberOfQuestion = questionList?.length;
      payload.assessmentQuestionVM = JSON.parse(JSON.stringify(assessmentQuestionVMTemp))
      payload.isActive = assessmentById.isActive ?? true
      payload.savedBy = assessmentById?.savedBy ?? userDetails?.emailId
      payload.updatedBy = userDetails?.emailId
      dispatch(setAssessmentCreationSuccess(''))
      dispatch(createAssessment(payload))
    }
  };

  const handleCancelClick = () => {
      let decriptionTxt = (
        <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
      );
      setSubmitPopupcontent({
        ...submitPopupcontent,
        titleImg: ConfirmationBee,
        title: "UNSAVED CHANGES",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "No",
        primaryBtnText: "Yes",
        popupOutlinebtnOnclick: () => popupOutlinebtnOnclickCancel(),
        popupPrimarybtnOnclick: () => {
          handleClickBack()
          setQuestionList([])
          setQuestionType([])
          setShowAssessmentAnswer(false)
        },
        isSingleConfirmationBtn: false,
      });
  }

  return <AssessmentQuestion
    questionTypes={questionTypes}
    onChangeQuestion={onChangeQuestion}
    optionTypeOnChange={optionTypeOnChange}
    showAssessmentAnswer={showAssessmentAnswer}
    onChangeQuantity={onChangeQuantity}
    incrementQuantity={incrementQuantity}
    decrementQuantity={decrementQuantity}
    quantity={quantity}
    onClickAddAnswerBtn={onClickAddAnswerBtn}
    questionList={questionList}
    submitPopupcontent={submitPopupcontent}
    handleClickSubmit={handleClickSubmit}
    hideDialogSubmit={hideDialogSubmit}
    onChangeOption={onChangeOption}
    onChangeOptionAnswer={onChangeOptionAnswer}
    onDeleteOption={onDeleteOption}
    onDeleteQuestion={onDeleteQuestion}
    handleCancelClick={handleCancelClick}
    assessmentTitle={assessmentTitle}
    isEditMode={isEditMode}
  />
}

export default AssessmentQuestionContainer;